import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiModule } from '../../shared/ui.module';
import { AwbRoutingModule } from './awb-routing.module';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbAccordionModule, NgbActiveModal, NgbModule, } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { ListAwbComponent } from 'src/app/components/operation/awb/list/list.component';
import { AddAwbComponent } from 'src/app/components/operation/awb/add/add.component';
import { EditAwbComponent } from 'src/app/components/operation/awb/edit/edit.component';
import { SharedModule } from '../../shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
//Service
import { AWBService } from 'src/app/services/operations/awb.service';
import { CompanyService } from 'src/app/services/company.service';
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { AddressBookService } from 'src/app/services/general/addressbook.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { PerformaComponent } from 'src/app/components/shared/performa-details/performadetails.component';
import { AwbChargesListComponent } from 'src/app/components/operation/awb/awb-charges/charge.component';
import { TrackingComponent } from 'src/app/components/operation/tracking/tracking.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { RateUploadService } from 'src/app/services/operations/rateupload.service';
import { ViewActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/view.component';
import { UpdatePODDetails } from 'src/app/components/operation/awb/pod-details/updatepod-details.component';
import { CommentsComponent } from 'src/app/components/operation/awb/comments/comments.component';
import { AwbInscanComponent } from 'src/app/components/operation/awb/awb-inscan/awb-inscan.component';
import { AwbReceivedComponent } from 'src/app/components/operation/awb/awb-received/awb-received.component';
import { AwbPiecesComponent } from 'src/app/components/operation/awb/awb-pieces/awb-pieces.component';
import { ChildAWBGridComponent } from 'src/app/components/operation/manifest/child-awbmodel/child-awb.component';
import { BagPrintComponent } from 'src/app/components/operation/manifest/bag-print/bag-print.component';
import { ConfigService } from 'src/app/services/system-config/configs/configs.service';
import { AwbSplitComponent } from 'src/app/components/operation/awb/awb-split/awb-split.component';
import { AwbAdditionalTatComponent } from 'src/app/components/operation/awb/awb-additional-tat/awb-additional-tat.component';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UploadDocumentComponent } from 'src/app/components/operation/awb/uploaddocument/upload-document.component';
// import { TabDirective } from 'src/app/models/directives/tab.directive';
import { ChildAWBComponent } from 'src/app/components/operation/awb/childawb-modal/child-awb.component';
import { LabelPrintComponent } from 'src/app/components/operation/awb/label-print/label-print.component';
import { compareRatesComponent } from 'src/app/components/operation/awb/compare-rates/compare-rates.component';
import { AddressComponent } from 'src/app/components/shared/address/address.component';
import { KycViewComponent } from 'src/app/components/operation/tracking/kyc-modal/kyc-view.component';


@NgModule({
  declarations: [
    ListAwbComponent,
    AddAwbComponent,
    EditAwbComponent,
    PerformaComponent,
    AwbChargesListComponent,
    TrackingComponent,
    KycViewComponent,
    UpdatePODDetails,
    CommentsComponent,
    AwbInscanComponent,
    AwbReceivedComponent,
    AwbPiecesComponent,
    ChildAWBGridComponent,
    BagPrintComponent,
    AwbSplitComponent,
    BagPrintComponent,
    AwbAdditionalTatComponent,
    UploadDocumentComponent,
    // TabDirective,
    ChildAWBComponent,
    LabelPrintComponent,
    compareRatesComponent,
    ViewActionsRenderer
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbNavModule,
    NgbDropdownModule,
    NgSelectModule,
    AwbRoutingModule,
    AgGridModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    NgbHighlight,
    NgbAccordionModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    SimplebarAngularModule,
    NgbModule

  ],
  exports: [
    ListAwbComponent,
    AddAwbComponent,
    EditAwbComponent,
    PerformaComponent,
    AwbChargesListComponent,
    TrackingComponent,
    KycViewComponent,
    UpdatePODDetails,
    CommentsComponent,
    AwbInscanComponent,
    AwbReceivedComponent,
    AwbPiecesComponent,
    ChildAWBGridComponent,
    BagPrintComponent,
    AwbSplitComponent,
    BagPrintComponent,
    AwbAdditionalTatComponent,
    UploadDocumentComponent,
    // TabDirective,
    ChildAWBComponent,
    LabelPrintComponent,
    compareRatesComponent
  ],
  providers: [
    AWBService,
    CompanyService,
    ProductService,
    VendorService,
    PickupService,
    ChargesService,
    AddressBookService,
    MiscService,
    UserManagementService,
    RateUploadService,
    ViewActionsRenderer,
    DatePipe,
    NgbActiveModal,
    ConfigService,
    NotificationsService
  ]
})
export class AwbModule { }
